import { Citation as CitationType } from '../types';

interface CitationProps {
  citation: CitationType;
}

/** Displays a single source file citation with path and last-modified date (FR-003). */
export default function Citation({ citation }: CitationProps) {
  const modified = new Date(citation.lastModified);
  const dateStr = modified.toLocaleDateString('en-AU', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  return (
    <span className="citation-tag">
      {citation.filePath} <span className="citation-date">({dateStr})</span>
    </span>
  );
}
